if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.hasAttribute('jersey-configurator')) {
          setTimeout(() => {
            if (document.querySelector('#variant-radios-' + this.getAttribute('data-section-id') + ' input[name="Size"]:checked'))
              document.querySelector('#variant-radios-' + this.getAttribute('data-section-id') + ' input[name="Size"]:checked').checked = false;
            if(document.querySelector('.product-info__delivery-time'))  document.querySelector('.product-info__delivery-time').classList.add('hidden');
          }, 50);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = '';

        //[Addition] if product is custom jersey, then add jersey bundle
        if (this.form.querySelector('input[name="badge-option"]') || this.form.querySelector('input[name="flock-option"]')) {
          formData = new FormData();
          let items = this.setFormItems();
          this.appendFormData(formData, 'items', items);
        } else {
          formData = new FormData(this.form);
        }
        //[Addition] if product is custom jersey, then add jersey bundle

        //[Addition] update personalized item unique id to make sure its always added as one item in cart
        if (this.hasAttribute('personalized-product')) {
          let personalizedItemUniqueID = new Date().valueOf();
          this.querySelector('.personalizedItemID') ? this.querySelector('.personalizedItemID').value = personalizedItemUniqueID : '';
        }
        //[Addition] update personalized item unique id to make sure its always added as one item in cart

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (this.querySelector('.cross-sell-items')) {
              this.querySelector('.cross-sell-items .flickity-viewport').style.height = this.querySelector('.cross-sell-items .flickity-slider').offsetHeight + 'px';
            }
            if (this.form.querySelector('input[name="properties[__member-gift]"]')) {

              let currentWrapper = document.querySelector('.scart-wrapper.current--2');
              if (currentWrapper) {
                currentWrapper.classList.remove('current--2');
                currentWrapper.classList.add('current--3');
              }
            }
            else if (this.form.querySelector('input[name="properties[__abo-aftv]"]')) {
              let currentWrapper = document.querySelector('.aftv-wrapper.current--1');
              if (currentWrapper) {
                currentWrapper.classList.remove('current--1');
                currentWrapper.classList.add('current--2');
              }
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              // document.body.addEventListener(
              //   'modalClosed',
              //   () => {
              //     setTimeout(() => {
              //       this.cart.renderContents(response);
              //     });
              //   },
              //   { once: true }
              // );
              this.cart.renderContents(response);
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      //[Addition] add jersey bundle when jersey product added to cart
      setFormItems() {
        let quantity = document.querySelector('.quantity__input[form="' + this.form.getAttribute('id') + '"]') ? document.querySelector('.quantity__input[form="' + this.form.getAttribute('id') + '"]').value : 1;
        let uniqueID = new Date().valueOf();
        let numberOfLinkedItems = 0;
        if (this.form.querySelector('input[name="badge-option"]')) {
          numberOfLinkedItems++;
        }
        if (this.form.querySelector('input[name="flock-option"]')) {
          numberOfLinkedItems++;
        }
        let items = [];
        //this to add in cart another jersey product not the normal one, only if configurator is used
        let configuratorVariantID = this.form.querySelector('input[name="id"]').getAttribute('jersey-configurator-variant-id');
        if (configuratorVariantID != '') {
          console.log('configuratorVariantID', configuratorVariantID);
          if (this.form.querySelector('input[name="badge-option"]')) {
            items.push({
              "id": this.form.querySelector('input[name="badge-option"]').value,
              "quantity": quantity,
              "properties": {
                "_id": uniqueID,
                "_name": "Badge Product",
                "_num_of_related_items": numberOfLinkedItems
              }
            }
            )
          }

          if (this.form.querySelector('input[name="flock-option"]')) {
            items.push({
              "id": this.form.querySelector('input[name="flock-option"]').value,
              "quantity": quantity,
              "properties": {
                "_id": uniqueID,
                "_name": "Flock Product",
                "_num_of_related_items": numberOfLinkedItems
              }
            }
            )
          }

          if (this.form.querySelector('input[name="flock-option"]')) {
            let flock_option = this.form.querySelector('input[name="flock-option"]');
            items.push({
              "id": configuratorVariantID,
              "quantity": quantity,
              "properties": {
                "_id": uniqueID,
                "Wunschname": flock_option ? flock_option.getAttribute('player-name') : '',
                "Wunschnummer": flock_option ? flock_option.getAttribute('player-number') : '',
                "_badge": this.form.querySelector('input[name="badge-option"]') ? this.form.querySelector('input[name="badge-option"]').getAttribute('data-title') : '',
                "_flock_type": flock_option ? (flock_option.getAttribute('is-individuell') === 'true' ? "Individuell" : "Spieler") : '',
                "_name": "Jersey Product",
                "_num_of_related_items": numberOfLinkedItems
              }
            }
            )
          } else {
            items.push({
              "id": configuratorVariantID,
              "quantity": quantity,
              "properties": {
                "_id": uniqueID,
                "Wunschname": this.form.querySelector('input[name="flock-option"]') ? this.form.querySelector('input[name="flock-option"]').getAttribute('player-name') : '',
                "Wunschnummer": this.form.querySelector('input[name="flock-option"]') ? this.form.querySelector('input[name="flock-option"]').getAttribute('player-number') : '',
                "_badge": this.form.querySelector('input[name="badge-option"]') ? this.form.querySelector('input[name="badge-option"]').getAttribute('data-title') : '',
                "_name": "Jersey Product",
                "_num_of_related_items": numberOfLinkedItems
              }
            }
            )
          }
        }
        return items;
      }

      appendFormData(formData, key, data) {
        if (data === Object(data) || Array.isArray(data)) {
          for (const i in data) this.appendFormData(formData, `${key}[${i}]`, data[i]);
        } else data && formData.append(key, data);
      }
      //[Addition] add jersey bundle when jersey product added to cart

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        if(this.errorMessageWrapper)
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
